// @flow
import * as React from 'react'
import styled from 'styled-components'
import { CTASecondary, H260, DipseaContentfulAssets } from '@components/shared'
import { colors } from '@components/shared/colors'
import { config, Hidden } from 'react-awesome-styled-grid'
import { contentfulLoader } from '../../services/images'
import { FadeInImage } from '@components/shared/FadeInImage'
import { LinkWithUtms } from '../../actions/navigationActions'

export default function RedeemBlock (): React.Node {
  return (
    <RedeemContainer>
      <Hidden xs={true} sm={true}>
        <RedeemCtaContainer>
          <H260 color={colors.midnightBlue}>Already received a gift?</H260>
          <LinkWithUtms pathname={`/redeem`}>
            <CTASecondary color={colors.orange} borderColor={colors.orange} styles={{ marginTop: '20px' }}>REDEEM NOW</CTASecondary>
          </LinkWithUtms>
        </RedeemCtaContainer>
        <RedeemImageContainer>
          <FadeInImage
            loader={contentfulLoader}
            src={DipseaContentfulAssets['redeem.png']}
            alt="Dipsea | redeem Gift"
            width={1578}
            height={1200}
          />
        </RedeemImageContainer>
      </Hidden>
      <Hidden md={true} lg={true} xl={true}>
        <RedeemImageContainer>
          <FadeInImage
            loader={contentfulLoader}
            src={DipseaContentfulAssets['redeem.png']}
            alt="Dipsea | redeem Gift"
            width={1578}
            height={1200}
          />
        </RedeemImageContainer>
        <RedeemCtaContainer>
          <H260 color={colors.midnightBlue}>Already <br/>received a gift?</H260>
          <LinkWithUtms pathname={`/redeem`}>
            <CTASecondary color={colors.orange} borderColor={colors.orange} styles={{ marginTop: '20px' }}>REDEEM NOW</CTASecondary>
          </LinkWithUtms>
        </RedeemCtaContainer>
      </Hidden>
    </RedeemContainer>
  )
}

const RedeemContainer = styled.div`
  background-color: ${colors.sand};
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 50px 20px 50px 20px;
  

  ${(props: any): string => config(props).media.md`
    padding: 0px;
    flex-direction: row;
    width: 90%;
    border-radius: 30px;
    margin-top: 80px;
    margin-bottom: 80px;
    height: 242px;
  `}
  ${(props: any): string => config(props).media.lg`
    width: 80%;
    margin-top: 80px;
    margin-bottom: 80px;
    height: 311px;
  `}
  ${(props: any): string => config(props).media.xl`
    width: 85%;
    margin-top: 80px;
    margin-bottom: 80px;
    height: 400px;
  `}

`
const RedeemCtaContainer = styled.div`
  display: inline-block;
  flex-grow: 1;
  width: 300px;
  ${(props: any): string => config(props).media.md`
    margin-left: 20px;
    width: auto;
  `}
  ${(props: any): string => config(props).media.lg`
    margin-left: 50px;
  `}
  ${(props: any): string => config(props).media.xl`
    margin-left: 75px;
  `}
`

const RedeemImageContainer = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  
  width: 335px;
  height: 256px;
  border-radius: 20px;
  margin-bottom: 30px;
  overflow: hidden;

  ${(props: any): string => config(props).media.md`
    border-radius: 26px 0px;
    margin-bottom: 0px;
    width: 307px;
    height: 242px;
  `}
  ${(props: any): string => config(props).media.lg`
    width: 356px;
    height: 311px;
  `}
  ${(props: any): string => config(props).media.xl`
    width: 526px;
    height: 400px;
  `}
`
